import axios from "axios";
import {
  documentSearchUrl,
  documentUrl,
  globalPartnerUrl,
  GlobalReceiptUrl,
} from "../../Config/Url";
import { documentTypes } from "../../Config/DocumentTypes";

const { calculation } = documentTypes;

export const calculationService = {
  documentSearch,
  documentDelete,
  documentCreate,
  documentLock,
  documentUpdate,
  getDocumentById,
  getPartnersByStoreId,
  documentDetails,
  getReceipts,
  documentCancel,
};

async function documentSearch(
  tenantId,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  partnerGuid,
  searchText,
  dateFrom,
  dateTo
) {
  return axios
    .put(documentSearchUrl, {
      tenantId,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      documentTypeId: calculation,
      storeId: Number(storeId),
      partnerGuid,
      searchText,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(
  date,
  storeId,
  partnerGuid,
  note,
  startDate,
  endDate,
  products
) {
  let items = products.map((item) => ({
    documentTypeId: calculation,
    priceIn: Number(item.price3),
    quantityIn: Number(item.quantity),
    productGuid: item.productGuid,
    priceOut: item.price2,
    priceOut2: Number(item.price),
    margin: item.margin,
    tax: item.tax,
  }));
  return axios
    .post(documentUrl, {
      documentTypeId: calculation,
      date,
      storeId,
      partnerGuid,
      note,
      startDate,
      endDate,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/lock`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(
  documentGuid,
  date,
  storeId,
  partnerGuid,
  note,
  startDate,
  endDate,
  products
) {
  let items = products.map((item) => ({
    documentDetailGuid: item.documentDetailGuid,
    documentTypeId: calculation,
    productGuid: item.productGuid,
    quantityIn: Number(item.quantityIn),
    priceIn: Number(item.priceIn),
    priceOut: Number(item.priceOut),
    priceOut2: Number(item.priceOut2),
    isActive: Boolean(item.isActive),
    margin: +item.margin,
    tax: +item.tax,
  }));
  return axios
    .put(`${documentUrl}/${documentGuid}`, {
      documentGuid,
      documentTypeId: calculation,
      storeId,
      partnerGuid,
      date,
      note,
      startDate,
      endDate,
      items,
    })
    .then()
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid, date, storeId, note, products) {
  return axios
    .get(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getPartnersByStoreId(storeId) {
  return axios
    .get(`${globalPartnerUrl}/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getReceipts(storeId, partnerId) {
  return axios
    .get(`${GlobalReceiptUrl}/${storeId}/${partnerId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCancel(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/storno`)
    .then((res) => res)
    .catch((err) => err.response);
}
